import Link from "next/link";
import Image from "next/image";
import React, { useState, useEffect } from "react";
import ReactTooltip from "react-tooltip";
import Loader from "../../Loader";
import { FacebookShareButton, TwitterShareButton } from "react-share";
import GenericMaleThumbnail from "../../../../public/images/thumbs-generic-male-1.png";
import GenericFemaleThumbnail from "../../../../public/images/thumbs-generic-female-1.png";
import FacebookIcon from "../../../../public/images/icons/fb-w.png";
import TwitterIcon from "../../../../public/images/icons/twitter-w.png";
import ShareIcon from "../../../../public/images/icons/link-w.png";
import styles from "../../../styles/candidate/parts/CandidateBanner.module.scss";

const basePath = process.env.SITE_URL;
const showMenu = React.createRef();
const clickMenu = () => {
  showMenu.current.classList.toggle(styles.show);
};

const CandidateBanner = ({ data, url }) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const loader = ({ src, width, quality }) => {
    const imageUrl = basePath;
    return `${imageUrl}${src}?w=${width}&q=${quality || 75}`;
  };

  const copyLink = () => {
    const el = document.createElement("input");
    el.value = `${basePath}elections/2022/candidates/${data.wp_slug}`;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
  };

  const shareName = () => {
    if (data.alternate_name !== null && data.alternate_name !== "") {
      return `PROFILE: ${data.first_name} "${data.alternate_name}" ${data.last_name} ${data.suffix} | Candidate for ${data.candidacy_set[0].contest.display_name} - 2022 elections #PHVote #WeDecide`;
    } else {
      return `PROFILE: ${data.first_name} ${data.last_name} ${data.suffix} | Candidate for ${data.candidacy_set[0].contest.display_name} - 2022 elections #PHVote #WeDecide`;
    }
  };

  return data ? (
    <div className={styles.bannerContainer}>
      <div className={styles.bannerWrapper}>
        <div className={styles.socialIcons}>
          <FacebookShareButton
            url={`${process.env.SITE_URL}elections/2022/candidates/${data.wp_slug}`}
            quote={shareName()}
          >
            <div className={styles.icon}>
              <Image
                loader={loader}
                src={FacebookIcon}
                alt="facebook"
                layout="responsive"
                width={25}
                height={25}
              />
            </div>
          </FacebookShareButton>

          <TwitterShareButton
            url={`${process.env.SITE_URL}elections/2022/candidates/${data.wp_slug}`}
            title={shareName()}
          >
            <div className={styles.icon}>
              <Image
                loader={loader}
                src={TwitterIcon}
                alt="twitter"
                layout="responsive"
                width={25}
                height={20}
              />
            </div>
          </TwitterShareButton>

          <div
            className={styles.icon}
            data-for={"tooltip"}
            data-tip={"Copied!"}
            data-event={"click"}
          >
            <Image
              loader={loader}
              src={ShareIcon}
              alt="Share"
              layout="responsive"
              width={25}
              height={25}
            />
          </div>
          {isMounted && (
            <ReactTooltip
              id="tooltip"
              globalEventOff={"click"}
              afterShow={copyLink}
            />
          )}
        </div>

        <div className={styles.imgWrapper}>
          {data.thumbnail ? (
            <Image
              src={data.thumbnail}
              alt={data.first_name}
              layout="fixed"
              width={140}
              height={140}
            />
          ) : (
            <Image
              loader={loader}
              src={
                (data.gender || "").toLowerCase() === "female"
                  ? GenericFemaleThumbnail
                  : GenericMaleThumbnail
              }
              alt="default image"
              layout="fixed"
              width={140}
              height={140}
            />
          )}
        </div>

        <div className={styles.details}>
          <p className={styles.label}>candidate</p>
          <h1 className={styles.candidateName}>
            {data.candidacy_set?.[0].raw_name}
          </h1>
          <p className={styles.politicalParty}>
            {data.candidacy_set?.[0].political_party.name}
          </p>
          <p className={styles.position}>
            RUNNING FOR {data.candidacy_set?.[0].contest.display_name}
            {data.candidacy_set?.[0].contest?.district !== null && (
              <>, {data.candidacy_set?.[0].contest?.district}</>
            )}
            {data.candidacy_set?.[0].contest?.city !== null && (
              <>, {data.candidacy_set?.[0].contest?.city}</>
            )}
            {data.candidacy_set?.[0].contest?.province !== null && (
              <>, {data.candidacy_set?.[0].contest?.province}</>
            )}
          </p>
        </div>
        <ul className={styles.breadcrumbs}>
          <li>
            <Link href="/" passHref>
              2022 Elections
            </Link>
          </li>
          <li>
            {data.candidacy_set[0].contest.scope === "NATIONAL" ? (
              <Link
                href="/elections/2022/races/president-vice-president"
                passHref
              >
                National Races
              </Link>
            ) : (
              <Link href="/elections/2022/metro-manila" passHref>
                Local Races
              </Link>
            )}
          </li>

          {data.candidacy_set?.[0].contest?.province !== null && (
            <li>
              <Link href="/elections/2022/metro-manila" passHref>
                {data.candidacy_set?.[0].contest?.province}
              </Link>
            </li>
          )}

          {data.candidacy_set?.[0].contest?.city !== null && (
            <li>
              <Link href="/elections/2022/metro-manila" passHref>
                {data.candidacy_set?.[0].contest?.city}
              </Link>
            </li>
          )}

          {data.candidacy_set?.[0].contest?.district !== null && (
            <li>
              <Link href="/elections/2022/metro-manila" passHref>
                {data.candidacy_set?.[0].contest?.district}
              </Link>
            </li>
          )}

          {data.candidacy_set[0].contest.scope === "NATIONAL" && (
            <li>
              <Link
                href={
                  data.candidacy_set[0].contest.display_name === "Senator"
                    ? "/elections/2022/races/senator"
                    : "/elections/2022/races/president-vice-president"
                }
                passHref
              >
                {data.candidacy_set[0].contest.display_name}
              </Link>
            </li>
          )}
          <li>
            {data.first_name} {data.last_name}
          </li>
        </ul>
      </div>

      <div className={styles.bannerMenu}>
        <ul>
          {/* <li
            className={`${styles.btnMenu} ${styles.activeBtn}`}
            onClick={clickMenu}
          >
            <button>
              <p className={styles.menuTitle}>LATEST NEWS</p>
              <div className={styles.icon}>
                <Image
                  loader={loader}
                  src={downArrow}
                  alt="arrow down"
                  width={15}
                  height={8}
                />
              </div>
            </button>
          </li> */}
          {/* <div className={styles.listMenu} ref={showMenu}>
            <li className={styles.active}>
              <Link href="#">
                <a>
                  <p className={styles.menuTitle}>LATEST NEWS</p>
                </a>
              </Link>
            </li>
            <li>
              <Link href="#">
                <a>
                  <p className={styles.menuTitle}>TOP QUESTIONS</p>
                </a>
              </Link>
            </li>
            <li>
              <Link href="#">
                <a>
                  <p className={styles.menuTitle}>PROMISES & STANCES</p>
                </a>
              </Link>
            </li>
            <li>
              <Link href="#">
                <a>
                  <p className={styles.menuTitle}>HIGHLIGHTS & CONtROVERSIES</p>
                </a>
              </Link>
            </li>
            <li>
              <Link href="#">
                <a>
                  <p className={styles.menuTitle}>WHAT PEOPLE SAY</p>
                </a>
              </Link>
            </li>
            <li>
              <Link href="#">
                <a>
                  <p className={styles.menuTitle}>
                    MORE ON {data.first_name} {data.last_name}
                  </p>
                </a>
              </Link>
            </li>
          </div> */}
        </ul>
      </div>

      <ul className={styles.breadcrumbs_m}>
        <li>
          <Link href="/" passHref>
            2022 Elections
          </Link>
        </li>
        <li>
          {data.candidacy_set[0].contest.scope === "NATIONAL" ? (
            <Link
              href="/elections/2022/races/president-vice-president"
              passHref
            >
              National Races
            </Link>
          ) : (
            <Link href="/elections/2022/metro-manila" passHref>
              Local Races
            </Link>
          )}
        </li>

        {data.candidacy_set?.[0].contest?.province !== null && (
          <li>
            <Link href="/elections/2022/metro-manila" passHref>
              {data.candidacy_set?.[0].contest?.province}
            </Link>
          </li>
        )}

        {data.candidacy_set?.[0].contest?.city !== null && (
          <li>
            <Link href="/elections/2022/metro-manila" passHref>
              {data.candidacy_set?.[0].contest?.city}
            </Link>
          </li>
        )}

        {data.candidacy_set?.[0].contest?.district !== null && (
          <li>
            <Link href="/elections/2022/metro-manila" passHref>
              {data.candidacy_set?.[0].contest?.district}
            </Link>
          </li>
        )}

        {data.candidacy_set[0].contest.scope === "NATIONAL" && (
          <li>
            <Link
              href={
                data.candidacy_set[0].contest.display_name === "Senator"
                  ? "/elections/2022/races/senator"
                  : "/elections/2022/races/president-vice-president"
              }
              passHref
            >
              {data.candidacy_set[0].contest.display_name}
            </Link>
          </li>
        )}
        <li>
          {data.first_name} {data.last_name}
        </li>
      </ul>
    </div>
  ) : (
    <Loader />
  );
};

export default CandidateBanner;
